import {enqueueSnackbar} from "notistack";

export default function infoToast(message) {
    return enqueueSnackbar(message, {
        variant: 'info',
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }
    })
}
